// use-case смены команды
// найти команду
// применить контекст команды
// перезагрузить коллекции
// перезагрузить теги
// редирект

import { applyTeamContext } from "./applyTeamContext";

export async function switchCurrentTeam({
  team,
  teamSlug,
  router,
  redirect = true,
  reloadCollections,
  reloadTags,
  mergePermissions,
}) {
  const targetTeam = await applyTeamContext({
    team,
    teamSlug,
    mergePermissions,
  });

  if (typeof reloadCollections === "function") {
    await reloadCollections(targetTeam.team.slug);
  }

  if (typeof reloadTags === "function") {
    await reloadTags(targetTeam.team.slug);
  }

  if (redirect && router && router.currentRoute.value.fullPath !== "/") {
    await router.push("/");
  }

  return targetTeam;
}
